import React from "react";
import "./style.css";

export default function ConfirmInviteModal({ open, onClose, contactName, category, emailOrPhone, photo, onConfirm }) {
  if (!open) return null;
  const name = contactName || "";
  const photoUrl = photo ? URL.createObjectURL(photo) : null;
  return (
    <div className="confirm-overlay">
      <div className="confirm-card">
        <div className="confirm-header">Would you like to invite this relationship to the Aris Platform?</div>
        <div className="confirm-person">
          <div className="confirm-avatar">
            <div className="avatar-circle">
              {photoUrl ? (
                <img src={photoUrl} alt={name} className="avatar-circle-img" />
              ) : (
                name ? name.split(" ").map(s => s[0]).join("") : ""
              )}
            </div>
            <div className="person-meta">
              <div className="person-name">{name || ""}</div>
              <div className="person-cat">{category || ""}</div>
            </div>
          </div>
        </div>
        <div className="confirm-dest">
          <div className="confirm-line">The invitation email will be sent to:</div>
          <div className="confirm-dest-email">{emailOrPhone}</div>
        </div>

        <div className="confirm-actions">
          <button className="primary" onClick={onConfirm}>Confirm</button>
          <button className="ghost" onClick={onClose}>Not Now</button>
        </div>
      </div>
    </div>
  );
}
